var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"announcement"},[_c('div',{staticClass:"announcement__icon"}),_vm._v(" "),_c('div',{staticClass:"announcement__title",domProps:{"innerHTML":_vm._s(_vm.announcement.title)}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"announcement__content",domProps:{"innerHTML":_vm._s(_vm.announcement.body)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6864cc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/announcement/announcement.vue
// module id = ci9y
// module chunks = 53